module.exports = __webpack_public_path__ + "static/img/BOM_img_3.d4d796f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/nav/img/BOM_img_3.png
// module id = e/CE
// module chunks = 22